<template>
  <div v-if="procedures">
    <h2>Select Procedures</h2>

    <div
      v-for="procedure in myProcedures"
      class="procedures"
      v-bind:key="procedure.procedureId"
    >
      <div class="wrapper" @click.prevent="clickedProcedure(procedure)">
        <div>
          <b>{{ procedure.procedureName }}</b>
          <div class="mt-2 text-muted">
            {{ (procedure.price / 100) | currency }}&nbsp;-&nbsp;
            {{ (procedure.minutes * 60 * 1000) | humanize }}
          </div>
        </div>
        <div>
          <div class="check">
            <i class="fas fa-check-square" v-if="procedure.isSelected"></i>
            <i class="far fa-square" v-if="!procedure.isSelected"></i>
          </div>
        </div>
      </div>
      <hr class="p-0 mb-3 mt-3" />
    </div>
  </div>
</template>

<script>
export default {
  props: { procedures: null },
  computed: {
    selectedProceduresList() {
      var selectedProcedures = this.myProcedures.filter((f) => f.isSelected);

      if (selectedProcedures.length > 0)
        return selectedProcedures.map((f) => f.procedureName).join(", ");
      else return "Select Procedures..";
    },
    selectedProcedures() {
      return this.myProcedures.filter((f) => f.isSelected).map((f) => f.id);
    },
  },
  watch: {
    myProcedures: {
      handler(newProcedures, oldVal) {
        console.log(newProcedures);
        this.$emit("updated", this.selectedProcedures);
      },
      deep: true,
    },
  },
  data() {
    return {
      myProcedures: null,
    };
  },
  created() {
    this.myProcedures = this.procedures.map((p) => {
      return {
        ...p,
        isSelected: false,
      };
    });
  },
  methods: {
    clickedProcedure(p) {
      p.isSelected = !p.isSelected;
    },
  },
};
</script>

<style scoped>
.check {
  font-size: 1.6em;
  color: #5a9ed2;
}
.procedures {
  max-width: 200px;
  min-width: 280px;
}
.wrapper {
  display: grid;
  cursor: pointer;
  padding-top: 20px;

  grid-template-columns: auto 25px;
}
</style>
